import { toPublicUrl } from "../../services/PublicUrl";
import "./ImplementationGuidePage.css";

export default function ImplementationGuidePage() {
  const implementationGuideUrl = toPublicUrl("/ig/index.html");

  return (
    <main className="implementation-guide-page">
      <iframe
        className="implementation-guide-page__frame"
        src={implementationGuideUrl}
        title="Juno FHIR Implementation Guide"
      />
    </main>
  );
}